/* Preserve the current resource, search, variant and section when changing market/language. */
(() => {
  const prepare = (form) => {
    if (!form.matches('form[action*="/localization"]')) return;
    let input = form.querySelector('input[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = location.pathname + location.search + location.hash;
  };
  document.querySelectorAll('form[action*="/localization"]').forEach(prepare);
  document.addEventListener('submit', (event) => prepare(event.target), true);
})();
